import React from 'react';
import { Users, CheckCircle, Clock, AlertCircle } from 'lucide-react';

export const DashboardIcons = {
  users: (props) => <Users {...props} />,
  checkCircle: (props) => <CheckCircle {...props} />,
  clock: (props) => <Clock {...props} />,
  alertCircle: (props) => <AlertCircle {...props} />,
};
